// extracted by mini-css-extract-plugin
export default {"title":"RegistrationGeneralForm_title__+vcuA","explanationText":"RegistrationGeneralForm_explanationText__o7IUm"};